export type ResolveGitsGithubOrganisationForAdditionalRequestArgs = {
  isGitsTeam: boolean;
  gitsGithubOrganisationChoices: string[];
  githubOrganisationsFromInfra?: string[];
  githubOrg?: string;
};

/**
 * Resolves the GitHub organisation name to send with additional-infrastructure requests for GITS teams
 * (Delivery Infra expects organisation alongside repository names for task metadata).
 */
export function resolveGitsGithubOrganisationForAdditionalRequest(
  args: ResolveGitsGithubOrganisationForAdditionalRequestArgs,
): string | undefined {
  const { isGitsTeam, gitsGithubOrganisationChoices, githubOrganisationsFromInfra, githubOrg } = args;
  if (!isGitsTeam) {
    return undefined;
  }
  const fromList = (gitsGithubOrganisationChoices.length > 0
    ? gitsGithubOrganisationChoices
    : githubOrganisationsFromInfra)?.filter((s) => String(s).trim().length > 0) ?? [];
  if (fromList.length > 0) {
    return fromList[0];
  }
  const orgField = githubOrg?.trim() ?? "";
  if (!orgField) {
    return undefined;
  }
  const fromUrl = orgField.match(/^https?:\/\/github\.com\/([^/?#]+)\/?$/i);
  if (fromUrl?.[1]) {
    return decodeURIComponent(fromUrl[1]);
  }
  return orgField;
}
